(function(){
    'use strict'

    angular.module('app.core')
    .factory('PreventTemplateCacheInterceptor', PreventTemplateCacheInterceptor);

    PreventTemplateCacheInterceptor.$inject = ['heligreenVersion'];

    function PreventTemplateCacheInterceptor(heligreenVersion) {
        
        var preventTemplateCacheInterceptor = {  
            request: function (config) {  
                
                if (config.url.indexOf('uib') === -1 && config.url.indexOf('.html') !== -1) {
                    config.url = config.url + '?t=' + heligreenVersion;
                  }

                return config;  
            } 
        };  
  
        return preventTemplateCacheInterceptor;  
    }
})();